var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditTableDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.842,
    height: 22.457,
    viewBox: "0 0 25.842 22.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "baseline-speaker_notes-24px",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_481",
    "data-name": "Caminho 481",
    d: "M0,0H25.842V22.457H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_482",
    "data-name": "Caminho 482",
    d: "M21.382,2H4.154A2.023,2.023,0,0,0,2.011,3.871L2,20.714l4.307-3.743H21.382A2.033,2.033,0,0,0,23.535,15.1V3.871A2.033,2.033,0,0,0,21.382,2ZM8.461,13.229H6.307V11.357H8.461Zm0-2.807H6.307V8.55H8.461Zm0-2.807H6.307V5.743H8.461ZM16,13.229H10.614V11.357H16Zm3.23-2.807H10.614V8.55h8.614Zm0-2.807H10.614V5.743h8.614Z",
    transform: "translate(0.153 -0.129)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTableDetails);
export default __webpack_public_path__ + "static/media/edit-table-details.bbcb05b7.svg";
export { ForwardRef as ReactComponent };